import { Sel, STagNew } from '#~/stag/index.js';
import { Icon } from '@studio/design-system/icon';
import * as Tabs from '@studio/design-system/tabs';
import type { ReactElement } from 'react';
import type { TriggersProps } from './types.js';
import { Tab } from './types.js';

// Per playwright-stag-selectors-only (ai.knowledge/platform): right-tray
// tab triggers get stable selectors so IR-039's defensive Step 4 click
// path (Controls tab fallback) does not depend on visible label text.
/** @internal */
export const Triggers = ({ disabled, ...props }: TriggersProps): ReactElement => (
  <Tabs.List {...props}>
    {/*
     * Per rule: playwright-stag-selectors-only (ai.knowledge/platform) —
     * STag attributes let HIL e2e tests switch tabs without text/role
     * fallback selectors (`getByText('Controls')` is fragile under i18n).
     */}
    <Tabs.Trigger
      disabled={disabled}
      value={Tab.Controls}
      {...STagNew(Sel.MainRoomRightTrayControls, 'tab', 'controls')}
    >
      <Icon icon='joystick' />
      Controls
    </Tabs.Trigger>

    <Tabs.Trigger
      disabled={disabled}
      value={Tab.Image}
      {...STagNew(Sel.MainRoomRightTrayControls, 'tab', 'image')}
    >
      <Icon icon='sliders' />
      Image
    </Tabs.Trigger>
  </Tabs.List>
);
